/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "ManageOpenRegistraionService";
const log: any = LoggerModule.getInstance();

export class ManageOpenRegistraionService {
  private static instance: ManageOpenRegistraionService;

  private criteria: any;

  private selectDropDown: any;

  private constructor(props: any = {}) { }

  public static getInstance(props: any = {}): ManageOpenRegistraionService {
    if (!ManageOpenRegistraionService.instance) {
      ManageOpenRegistraionService.instance = new ManageOpenRegistraionService(
        props
      );
    }
    return ManageOpenRegistraionService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }
  public async getInviteTable(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getMyCommitteInviteStatusProps();

    if (compProps) {
      content = { ...content, ...compProps };
    }

    compProps = await agent.getInviteTableProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log(
      "value for get Invite Table in index.ts mange open reg service",
      compProps
    );
    return content;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    compProps = await agent.getMasqueraderListsProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    compProps = await agent.getPresentationListsProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getInviteUser() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = await agent?.getInviteUserProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log("response from be open reg====", content);
    return content;
  }

  public async sendPurchaseInvite(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.sendPurchaseInviteUser(args);
  }
  public async getSection(args: any) {
    const agent = getAgent();
    return agent.getSectionProps(args);
  }

  public async getPresentation() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getPresentationListsProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async recallInvite(args: any) {
    log.info(`recall user`, args);
    const agent = getAgent();
    return agent.recallInviteUser(args);
  }
}
